/*
  プライバシーポリシーダイアログ
*/

import React from 'react';
import FullScreenDialog from 'js/shared/components/FullscreenDialog';

const PrivacyPolicyDialog = (props) => {
  return (
    <FullScreenDialog {...props} title="プライバシーポリシー">
      <h1>プライバシーポリシー</h1>
      <h2>個人情報保護方針</h2>
      <br />
      <p>
        株式会社リベライズは、テクノロジーを社会課題の解決し、より豊かな社会を実現するためにITソリューションの活用を支援しています。当社では事業運営上多くのお客様や従業者の個人情報を取扱うこととなるため、当社倫理綱領に基づいて本方針を定め、個人情報管理体制を確立し、企業として責任ある対応を実現するものとします。
      </p>
      <ul>
        <li>
          方針1.個人情報の利用の目的をできる限り特定し、当該目的の達成に必要な範囲内で適切に取扱います。また、目的外利用を行わないための措置を講じます。
        </li>
        <li>方針2.個人情報は、適法かつ適正な方法で取得します。</li>

        <li>方針3.個人情報は、本人の同意なく第三者に提供しません。</li>
        <li>
          方針4.個人情報の管理にあたっては、漏洩・滅失・毀損の防止及び是正、その他の安全管理のために必要かつ適切な措置を講じるよう努めます。
        </li>
        <li>
          方針5.個人情報の取扱いにあたっては、その情報を提供した本人が適切に関与し得るよう努め、可能な限り正確かつ最新の内容に保つよう努力します。
        </li>
        <li>
          方針6.個人情報保護に関する法令を遵守し、また個人情報保護に関する社内規程を定め、継続的な見直しを行い遵守します。
        </li>
        <li>
          方針7.個人情報保護に関する苦情及び相談に対応する窓口を設けて、適切に対応するよう努めます。
        </li>
      </ul>
      <br />
      株式会社リベライズ
      <br />
      代表取締役&nbsp;林部高弘
      <br />
      （附則）
      <br />
      <ul>
        <li>2020年08月01日制定・施行</li>
      </ul>
      <h3>プライバシーポリシー</h3>
      <br />
      <p>
        株式会社リベライズ（以下「当社」といいます）は、お弁当あーる（以下「本サービス」といいます）をご利用になる方（以下「お客様」といいます）のプライバシーを尊重し、お客様の個人情報(以下の定義に従います)の管理に細心の注意を払い、これを取扱うものとします。
      </p>
      <br />
      <h3>個人情報</h3>
      <br />
      <p>
        個人情報とは、お客様個人に関する情報であって、当該情報を構成する氏名、住所、電話番号、メールアドレス、学校名その他の記述等により当該お客様を識別できるものをいいます。また、その情報のみでは識別できない場合でも、他の情報と容易に照合することができ、結果的にお客様個人を識別できるものも個人情報に含まれます。
      </p>
      <br />
      <h3>個人情報の利用目的</h3>
      <br />
      <p>個人情報の利用目的は以下の通りです。利用目的を超えて利用することはありません。</p>
      <br />
      <p>A.会員の個人認証及び会員向け各種サービスの提供</p>
      <br />
      <p>B.サービスの利用に伴う各種連絡・お知らせの配信</p>
      <br />
      <p>
        C.お客様の申込みに基づく、広告掲載企業・団体等（以下「広告主」といいます）への個人情報の提供
      </p>
      <br />
      <p>D.本サービスの運用に伴う一時的なバックアップ保管</p>
      <br />
      <p>E.各種アンケート、キャンペーン等への応募受付及び当選者への連絡、プレゼント発送</p>
      <br />
      <p>F.記事作成等におけるモニターや取材対象者の応募受付及び対象者への連絡</p>
      <br />
      <p>G.別途ご同意いただいたお客様へのメールマガジン、各種お知らせ等の情報配信</p>
      <br />
      <p>H.別途ご同意いただいたお客様への取材、アンケート要請のご連絡</p>
      <br />
      <p>I.空メール送信者に対するURL情報の配信</p>
      <br />
      <p>J.本サービスに関するご意見、お問い合わせへの回答</p>
      <br />
      <p>
        K.お客様規約で禁じている、商用・転用目的での予約行為、権利譲渡、多重予約、虚偽情報登録などの調査と、それに基づく当該予約内容の詳細確認
      </p>
      <br />
      <p>L.予約システムに基づく、予約確認のご連絡</p>
      <br />
      <h3>個人情報提供の任意性</h3>
      <br />
      <p>
        本サービスの各サービスの実施においてそれぞれ必要となる項目を入力いただかない場合は、各々のサービスを受けられない場合があります。
      </p>
      <br />
      <h3>個人情報の第三者への提供</h3>
      <p>
        当社は、原則として、お客様ご本人の同意を得ずに個人情報を第三者に提供しません。提供先・提供情報内容を特定したうえで、お客様の同意を得た場合に限り提供します。ただし、以下の場合は、関係法令に反しない範囲で、お客様の同意なく個人情報を提供することがあります。
      </p>
      <br />
      <p>A.お客様が第三者に不利益を及ぼすと判断した場合</p>
      <br />
      <p>
        B.公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、お客様ご本人の承諾を得ることが困難である場合
      </p>
      <br />
      <p>
        C.国の機関若しくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合で、お客様ご本人の同意を得ることによりその事務の遂行に支障を及ぼすおそれがある場合
      </p>
      <br />
      <p>
        D.裁判所、検察庁、警察、弁護士会、消費者センターまたはこれらに準じた権限を有する機関から、個人情報についての開示を求められた場合
      </p>
      <br />
      <p>E.お客様ご本人から明示的に第三者への開示または提供を求められた場合</p>
      <br />
      <p>F.法令により開示または提供が許容されている場合</p>
      <br />
      <p>G.利用目的の達成に必要な範囲内において個人情報取扱い業務の一部または全部を委託する場合</p>
      <br />
      <p>
        H.合併その他の事由による事業の承継に伴い個人情報を提供する場合であって、承継前の利用目的の範囲で取り扱われる場合
      </p>
      <br />
      <h3>第三者提供に関する免責事項</h3>
      <br />
      <p>以下の場合、第三者による個人情報の取得に関し、当社は何らの責任を負いません。</p>
      <br />
      <p>
        A.お客様自らが本サービスにて予約などを申込み、広告主に個人情報を明らかにする場合（なお、広告主における個人情報の取り扱いについては、各企業・団体に直接お問い合わせ下さい）
      </p>
      <br />
      <p>B.本サービスに入力した情報により、期せずして本人が特定できてしまった場合</p>
      <br />
      <p>
        C.本サービスからリンクされる外部サイトにおいて、お客様より個人情報が提供され、またそれが利用された場合
      </p>
      <br />
      <p>D.お客様ご本人以外がお客様個人を識別できる情報（ID・パスワード等）を入手した場合</p>
      <br />
      <h3>予約システム利用におけるご注意</h3>
      <br />
      <p>
        本サービスの「予約システム」は、当社が、飲食店への予約連絡を代行するサービスです。本サービスによりご送信いただいた個人情報は、予約、各種お知らせの電子メール送信、各種電話連絡などの目的で、各飲食店が保管します。各飲食店が保管する個人情報の取扱については、各飲食店に直接お問合せください。なお、当社は円滑なサービス提供のため、メールアドレスのみ保管します。電話番号不備などの理由により、飲食店からの連絡が出来なかった場合、当社から確認のメールをお送りするために利用します。また、上記とは別に、当社は、バックアップ目的で、お預かりした個人情報を一定期間保管いたします。
      </p>
      <br />
      <h3>個人情報処理の外部委託</h3>
      <br />
      <p>当社は、個人情報取扱い業務の一部または全部を外部委託することがあります。</p>
      <br />
      <p>なお、委託先における個人情報の取扱いについては当社が責任を負います。</p>
      <br />
      <h3>統計処理されたデータの利用</h3>
      <br />
      <p>
        当社は、提供を受けた個人情報をもとに、個人を特定できないよう加工した統計データを作成することがあります。個人を特定できない統計データについては、当社は何ら制限なく利用することができるものとします。
      </p>
      <br />
      <h3>個人情報の変更等</h3>
      <br />
      <p>
        原則としてお客様本人に限り、「個人情報の利用目的」の通知、登録した個人情報の開示、訂正、追加または削除、利用停止、ならびに第三者への提供の停止を求めることができるものとします。
      </p>
      <br />
      <p>
        →お問い合わせは
        <a href="https://libelize.com/%E3%81%8A%E5%95%8F%E3%81%84%E5%90%88%E3%82%8F%E3%81%9B/">
          こちら
        </a>
        から
      </p>
      <br />
      <p>ただし、以下の場合は開示に応じないことがあります。</p>
      <br />
      <p>A.お客様本人または第三者の生命、身体、財産その他の権利・利益を害するおそれがある場合</p>
      <br />
      <p>B.本サービスの適正な実施に著しい支障を及ぼすおそれがある場合</p>
      <br />
      <p>C.他の法令に違反することとなる場合</p>
      <br />
      <p>
        情報の利用停止・第三者への提供の停止（以下「利用停止等」といいます）に多額の費用を要する場合、その他の利用停止等を行うことが困難な場合であって、お客様の権利・利益を保護するため必要なこれに代わるべき措置をとるときは、利用停止等に応じないことがあります。
      </p>
      <br />
      <h3>個人情報の正確性</h3>
      <br />
      <p>
        当社は、ご提供いただいた個人情報を正確にデータ処理するように努めます。ただし、ご提供いただいた個人情報の内容が正確かつ最新であることについては、お客様が責任を負うものとします。
      </p>
      <br />
      <h3>機微な個人情報の取得制限</h3>
      <p>
        当社は、次に示す内容を含む個人情報の取得は原則として行いません。ただし、お客様が自ら提供した場合は、この限りではありません。
      </p>
      <br />
      <p>A.思想、信条及び宗教に関する事項</p>
      <br />
      <p>
        B.人種、民族、門地、本籍地（所在都道府県に関する情報を除く）、身体・精神障害、犯罪歴、その他社会的差別の原因となる事項
      </p>
      <br />
      <p>C.勤労者の団結権、団体交渉及びその他団体行動の行為に関する事項</p>
      <br />
      <p>D.集団示威行為への参加、請願権の行使、及びその他政治的権利の行使に関する事項</p>
      <br />
      <p>E.保健医療及び性生活</p>
      <br />
      <h3>個人情報の管理について</h3>
      <br />
      <p>
        当社は、その管理下にある個人情報の紛失、誤用、改変を防止するために、適切なセキュリティ対策の実施に努めています。個人情報は、一般の利用者がアクセスできない安全な環境下に保管しています。
      </p>
      <br />
      <h3>本人確認について</h3>
      <br />
      <p>
        当社は、本サービスへの会員登録や会員がサービスを利用する場合、個人情報の開示、訂正、削除もしくは利用停止の求めに応じる場合など、個人を識別できる情報（氏名、住所、電話番号、生年月日、メールアドレス、会員番号、パスワードなど）により、本人であることを確認します。ただし、本人以外が個人を識別できる情報を入手し使用した場合、当社は責任を負いません。
      </p>
      <br />
      <h3>個人を特定しない属性情報・行動履歴の取得及び利用について</h3>
      <br />
      <p>
        当社は、お客様のプライバシーの保護、利便性の向上、広告の配信、及び統計データの取得のため、Cookieを使用します。また、当社は、CookieやJavaScript、スマートフォンおよびアプリケーション等の技術を利用して、会員登録時等にご提供いただいた情報のうち年齢や性別、職業、居住地域など個人が特定できない属性情報（組み合わせることによっても個人が特定できないものに限られます）や、サイト内におけるお客様の行動履歴（アクセスしたURL、コンテンツ、参照順等）、スマートフォンおよびアプリケーション利用時の位置情報を取得することがあります。ただし、Cookie及び行動履歴には個人情報は一切含まれません。
      </p>
      <br />
      <p>
        なお、本サービスでは、お客様に適切な広告を配信するために行動ターゲティング広告サービスを利用しています。このサービスを無効にしたい場合は、
        <a href="https://libelize.com/%E3%81%8A%E5%95%8F%E3%81%84%E5%90%88%E3%82%8F%E3%81%9B/">
          こちら
        </a>
        へお問い合わせください。
      </p>
      <br />
      <h3>個人情報管理責任者</h3>
      <br />
      <p>株式会社リベライズ&nbsp;代表取締役&nbsp;林部高弘</p>
      <br />
      <p>
        お問い合わせは
        <a href="https://libelize.com/%E3%81%8A%E5%95%8F%E3%81%84%E5%90%88%E3%82%8F%E3%81%9B/">
          こちら
        </a>
        からお願いいたします。
      </p>
      <br />
      <h3>プライバシーポリシーの変更</h3>
      <br />
      <p>
        当社は、法令等の定めがある場合を除き、プライバシーポリシーを随時変更することができるものとします。
      </p>
    </FullScreenDialog>
  );
};
export default PrivacyPolicyDialog;
